__turbopack_context__.v({
  "billing": "Pricing-module__GqQ-iW__billing",
  "container": "Pricing-module__GqQ-iW__container",
  "cta": "Pricing-module__GqQ-iW__cta",
  "feature": "Pricing-module__GqQ-iW__feature",
  "featureText": "Pricing-module__GqQ-iW__featureText",
  "features": "Pricing-module__GqQ-iW__features",
  "founderBadge": "Pricing-module__GqQ-iW__founderBadge",
  "included": "Pricing-module__GqQ-iW__included",
  "period": "Pricing-module__GqQ-iW__period",
  "periodActive": "Pricing-module__GqQ-iW__periodActive",
  "periodSave": "Pricing-module__GqQ-iW__periodSave",
  "periods": "Pricing-module__GqQ-iW__periods",
  "plan": "Pricing-module__GqQ-iW__plan",
  "planHead": "Pricing-module__GqQ-iW__planHead",
  "planName": "Pricing-module__GqQ-iW__planName",
  "planPro": "Pricing-module__GqQ-iW__planPro",
  "plans": "Pricing-module__GqQ-iW__plans",
  "price": "Pricing-module__GqQ-iW__price",
  "priceAmount": "Pricing-module__GqQ-iW__priceAmount",
  "priceStruck": "Pricing-module__GqQ-iW__priceStruck",
  "priceTalk": "Pricing-module__GqQ-iW__priceTalk",
  "priceUnit": "Pricing-module__GqQ-iW__priceUnit",
  "priceVat": "Pricing-module__GqQ-iW__priceVat",
  "srOnly": "Pricing-module__GqQ-iW__srOnly",
  "tagline": "Pricing-module__GqQ-iW__tagline",
  "volume": "Pricing-module__GqQ-iW__volume",
  "volumeChevron": "Pricing-module__GqQ-iW__volumeChevron",
  "volumeChevronOpen": "Pricing-module__GqQ-iW__volumeChevronOpen",
  "volumeMenu": "Pricing-module__GqQ-iW__volumeMenu",
  "volumeMenuWrapper": "Pricing-module__GqQ-iW__volumeMenuWrapper",
  "volumeOption": "Pricing-module__GqQ-iW__volumeOption",
  "volumeOptionActive": "Pricing-module__GqQ-iW__volumeOptionActive",
  "volumePrice": "Pricing-module__GqQ-iW__volumePrice",
  "volumeTrigger": "Pricing-module__GqQ-iW__volumeTrigger",
  "volumeUnit": "Pricing-module__GqQ-iW__volumeUnit",
  "volumeValue": "Pricing-module__GqQ-iW__volumeValue",
});
